import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { isExpectedApiError } from '@/utils/errors';

export function getContext() {
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: 30_000,
				retry: (failureCount, error) => !isExpectedApiError(error) && failureCount < 2,
			},
		},
	});
	return {
		queryClient,
	};
}

export function Provider({ children, queryClient }: { children: React.ReactNode; queryClient: QueryClient }) {
	return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
